import React from 'react';
import styled from 'styled-components';
import { FaImage, FaComments, FaMastodon } from 'react-icons/fa';
import { SiMastodon } from 'react-icons/si';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  min-height: 100vh;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  color: #dfe6e9;
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  color: #b2bec3;
  max-width: 600px;
  margin: 0 auto;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
`;

const Card = styled.div`
  background: #2d3436;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
  border: 1px solid #3d4346;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(116, 185, 255, 0.2);
  }
`;

const Content = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const CardTitle = styled.h3`
  margin: 0 0 0.5rem 0;
  color: #dfe6e9;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const Icon = styled.div`
  font-size: 1.5rem;
  color: #74b9ff;
`;

const Description = styled.p`
  margin: 0 0 1rem 0;
  color: #b2bec3;
  font-size: 0.9rem;
`;

const Link = styled.a`
  background-color: #74b9ff;
  color: #2d3436;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.2s;
  text-align: center;
  margin-top: auto;

  &:hover {
    background-color: #0984e3;
  }
`;

const SocialPage: React.FC = () => {
  return (
    <Container>
      <Header>
        <PageTitle>Social Media</PageTitle>
        <Subtitle>
          Connect with me on various platforms to stay updated with my latest projects and game development journey.
        </Subtitle>
      </Header>
      <Grid>
        <Card>
          <Content>
            <CardTitle>
              <Icon><FaMastodon /></Icon>
              Mastodon
            </CardTitle>
            <Description>
              Follow me on Mastodon for game development updates, thoughts on indie games, and occasional memes.
              I'm part of the gamedev.place community, a great place for game developers to connect and share.
            </Description>
            <Link href="https://mastodon.gamedev.place/@armen" target="_blank" rel="noopener noreferrer">
              Follow on Mastodon
            </Link>
          </Content>
        </Card>
        <Card>
          <Content>
            <CardTitle>
              <Icon><FaImage /></Icon>
              Pixelfed
            </CardTitle>
            <Description>
              Check out my Pixelfed profile for game development screenshots, work-in-progress shots, and behind-the-scenes content.
              A great way to see the visual side of my game development process.
            </Description>
            <Link href="https://pixelfed.ca/armen" target="_blank" rel="noopener noreferrer">
              View on Pixelfed
            </Link>
          </Content>
        </Card>
        <Card>
          <Content>
            <CardTitle>
              <Icon><FaComments /></Icon>
              Matrix Chat
            </CardTitle>
            <Description>
              Join me in the Matrix chat room for real-time discussions about game development, programming, and other tech topics.
              A great place to connect with other developers and share ideas.
            </Description>
            <Link href="https://matrix.to/#/#irc_#general:matrix.f-hub.org" target="_blank" rel="noopener noreferrer">
              Join Chat Room
            </Link>
          </Content>
        </Card>
      </Grid>
    </Container>
  );
};

export default SocialPage; 